import state from './state.js'
import router from '../router/store.js'
import { serializeState } from './utility-storage.js'

/**
 * State observer
 * updates local storage based on responses
 */
let _localStorageTimeout = null;
let _lastLocalStorageValue = null;

const updateLocalStorage = () => {
  clearTimeout(_localStorageTimeout)
  if (state.isStatic) {
    localStorage.removeItem(state.localStorageKey)
    return;
  };
  _localStorageTimeout = setTimeout(() => {
    const { serialized, serializedWithFlag } = serializeState({
      t: Date.now()
    })
    if (serialized === _lastLocalStorageValue) return;
    _lastLocalStorageValue = serialized;
    localStorage.setItem(
      state.localStorageKey,
      serializedWithFlag
    )
  }, 300)
}

state.addObserver((name) => {
  switch (name) {
    case 'responses':
    case 'orderLines':
    case 'customer':
    case 'resultsId':
    case 'resultsHandle':
    case 'isStatic':
      updateLocalStorage();
  }
})

router.addObserver((name) => {
  switch (name) {
    case 'path':
      updateLocalStorage()
  }
})